export const baseURL = process.env.REACT_APP_API_BASE_URL;
export const token = process.env.REACT_APP_API_TOEKN;
export const loginURL = process.env.REACT_APP_AUTH_BASE_URL;
export const queryString = {
    api_key: token
} 